import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { ApiService } from 'app/shared/services/api.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-course-reports',
  templateUrl: './course-reports.component.html',
  styleUrls: ['./course-reports.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CourseReportsComponent implements OnInit {
  @ViewChild(DatatableComponent) table: DatatableComponent;
  page = {
    pageNumber:0,
    offset: 0,
    pageSize: 100,
    totalPages:0
  };
  public rows:any = [];
  public ColumnMode = ColumnMode;
  public limitRef = 100;
  startDate :any
  endDate:any
  public courseTypeView: boolean[] = [];

  constructor(public apiService:ApiService,
    private spinner: NgxSpinnerService,private route: ActivatedRoute) {
      
     }

  ngOnInit(): void {
    // this.route.queryParamMap.subscribe((params) => {
    //   let month = params.get('month');
    //   let year = params.get('year');
    // })
    const monthAgo = new Date();
    monthAgo.setDate(monthAgo.getDate() - 30);
    this.startDate = monthAgo.toISOString().split('T')[0];

    this.endDate = new Date().toISOString().split('T')[0];

    this.getReports(this.startDate,this.endDate)
  }

  getReports(start,end){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.getCourseReports(start,end).subscribe((res:any)=>{
      this.spinner.hide();
      this.rows = res?.data
      
    })
  }
  getStartDate(event){
    this.startDate = event.target.value
    if(this.startDate && this.endDate){
      this.getReports(this.startDate,this.endDate)
    }
  }
  getEndDate(event){
    this.endDate = event.target.value
    if(this.startDate && this.endDate){
      this.getReports(this.startDate,this.endDate)
    }
  }

}
